import getMonetateExperience from '../../app/utils/monetate/getMonetateExperience';
import moveL2CategoriesToEnd from './move-L2-categories-to-end';

const pipe = (...fns) => x => fns.reduce((v, f) => f(v), x);

export const overrideCategory = categoryOverrides => categories => {
  if (!categoryOverrides || !categories) return categories;
  const override = categoryOverrides?.[categories.id];
  const overridenCategory = override || categories;
  if (!Array.isArray(categories.child)) return overridenCategory;
  return {
    ...overridenCategory,
    child: overridenCategory.child.map(childCategories =>
      overrideCategory(categoryOverrides)(childCategories)
    ),
  };
};

const replaceCategoryChild = (category, content, columnName) => ({
  ...category,
  child: [...category.child.filter(({ name }) => name !== columnName), content],
});

export const mergeContentBlocks = (
  features,
  contentBlocks = []
) => categories => {
  if (contentBlocks.length === 0) return categories;
  const contentBlocksExperience = getMonetateExperience(
    features,
    'content-blocks'
  );
  const categoriesToReplace = contentBlocksExperience?.parameters?.categories?.split(
    ','
  );

  if (categoriesToReplace?.length > 0) {
    return {
      ...categories,
      child: contentBlocks?.length
        ? categories.child.map(category => {
            const categoryParams = categoriesToReplace.find(
              c => c.trim().split('|')[0] === category.name
            );

            const content = contentBlocks.find(
              c => c.category === category.name
            );

            return categoryParams && content
              ? replaceCategoryChild(
                  category,
                  content,
                  categoryParams.trim().split('|')[1]
                )
              : category;
          })
        : categories.child,
    };
  }

  return categories;
};

export const swapTopLevelCategories = features => categories => {
  const swapData = getMonetateExperience(features, 'swap-categories');

  const fromPos = categories?.child?.findIndex(category => {
    const [{ name = '' } = {}] = swapData?.parameters || [];
    return category.name === name;
  });
  const [{ position: toPos = -1 } = {}] = swapData?.parameters || [];
  return swapData && fromPos >= 0 && toPos >= 0 && fromPos !== toPos
    ? {
        ...categories,
        child:
          fromPos < toPos
            ? [
                ...categories.child.slice(0, fromPos),
                ...categories.child.slice(fromPos + 1, toPos + 1),
                categories.child[fromPos],
                ...categories.child.slice(toPos + 1),
              ]
            : [
                ...categories.child.slice(0, toPos),
                categories.child[fromPos],
                ...categories.child.slice(toPos, fromPos),
                ...categories.child.slice(fromPos + 1),
              ],
      }
    : categories;
};

const enrichCategories = (
  features = {},
  categoryOverrides = {},
  contentBlocks = [],
  categories = { child: [] }
) =>
  pipe(
    mergeContentBlocks(features, contentBlocks),
    overrideCategory(categoryOverrides),
    swapTopLevelCategories(features),
    moveL2CategoriesToEnd(features)
  )(categories);

export default enrichCategories;
